/* =====================================================
   SCHUTZHOUSE — Theme JS v2
   Luxury Minimal. Urban Protection System.
   ===================================================== */

/* ---- STATE ---- */
var cartOpen = false;
var mobileOpen = false;
var searchOpen = false;

/* ---- UTILS ---- */
function $(id) { return document.getElementById(id); }
function lockScroll() { document.body.style.overflow = 'hidden'; }
function unlockScroll() { document.body.style.overflow = ''; }
function money(cents) { return '\u20a6' + Math.round(cents / 100).toLocaleString('en-NG'); }

/* ---- CART ---- */
function openCartPanel() {
  cartOpen = true;
  $('CartPanel').classList.add('on');
  $('CartVeil').classList.add('on');
  lockScroll();
  fetchCart();
}
function closeCartPanel() {
  cartOpen = false;
  $('CartPanel').classList.remove('on');
  $('CartVeil').classList.remove('on');
  unlockScroll();
}
async function fetchCart() {
  try {
    var res = await fetch('/cart.js');
    var cart = await res.json();
    renderCart(cart);
  } catch(e) {}
}
function renderCart(cart) {
  var countEl = $('CartCount');
  var panelCountEl = $('CartPanelCount');
  var subtotalEl = $('CartSubtotal');
  var bodyEl = $('CartBody');

  if (countEl) countEl.textContent = cart.item_count;
  if (panelCountEl) panelCountEl.textContent = cart.item_count;
  if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

  if (!bodyEl) return;
  if (cart.items.length === 0) {
    bodyEl.innerHTML = '<p style="padding:3rem 0;text-align:center;font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--muted);">Your cart is empty</p>';
    return;
  }
  bodyEl.innerHTML = cart.items.map(function(item) {
    return [
      '<div class="cart-item">',
        '<div class="cart-item-img">',
          item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '',
        '</div>',
        '<div>',
          '<div class="cart-item-title">' + item.product_title + '</div>',
          '<div class="cart-item-meta">Qty ' + item.quantity + '</div>',
          '<div class="cart-item-price">' + money(item.final_line_price) + '</div>',
        '</div>',
      '</div>'
    ].join('');
  }).join('');
}
async function addToCart(variantId, qty) {
  try {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: variantId, quantity: qty || 1})
    });
    if (res.ok) {
      var cart = await (await fetch('/cart.js')).json();
      renderCart(cart);
      openCartPanel();
    }
  } catch(e) {}
}

/* ---- MOBILE MENU ---- */
function openMobile() {
  mobileOpen = true;
  $('MobileMenu').classList.add('on');
  $('MobileVeil').classList.add('on');
  lockScroll();
}
function closeMobile() {
  mobileOpen = false;
  $('MobileMenu').classList.remove('on');
  $('MobileVeil').classList.remove('on');
  unlockScroll();
}

/* ---- SEARCH ---- */
function openSearch() {
  searchOpen = true;
  $('SearchOverlay').classList.add('open');
  lockScroll();
  setTimeout(function(){ var i = $('SearchOverlay').querySelector('input'); if(i) i.focus(); }, 80);
}
function closeSearch() {
  searchOpen = false;
  $('SearchOverlay').classList.remove('open');
  unlockScroll();
}

/* ---- HEADER SCROLL ---- */
var header = $('SiteHeader');
var lastY = 0;
if (header) {
  window.addEventListener('scroll', function() {
    var y = window.scrollY;
    header.classList.toggle('at-top', y < 10);
    lastY = y;
  }, { passive: true });
  header.classList.toggle('at-top', window.scrollY < 10);
}

/* ---- SCROLL REVEAL ---- */
var revealObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObs.unobserve(e.target);
    }
  });
}, { rootMargin: '0px 0px -50px 0px', threshold: 0.06 });

function initReveal() {
  document.querySelectorAll('.reveal').forEach(function(el) {
    revealObs.observe(el);
  });
}

/* ---- EVENT LISTENERS ---- */
document.addEventListener('DOMContentLoaded', function() {

  /* Cart */
  var cartBtn = $('CartBtn');
  var cartClose = $('CartClose');
  var cartVeil = $('CartVeil');
  if (cartBtn) cartBtn.addEventListener('click', openCartPanel);
  if (cartClose) cartClose.addEventListener('click', closeCartPanel);
  if (cartVeil) cartVeil.addEventListener('click', closeCartPanel);

  /* Mobile */
  var mobileBtn = $('MobileMenuBtn');
  var mobileClose = $('MobileClose');
  var mobileVeil = $('MobileVeil');
  if (mobileBtn) mobileBtn.addEventListener('click', openMobile);
  if (mobileClose) mobileClose.addEventListener('click', closeMobile);
  if (mobileVeil) mobileVeil.addEventListener('click', closeMobile);

  /* Search */
  var searchBtn = $('SearchBtn');
  var searchClose = $('SearchClose');
  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  /* Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (cartOpen) closeCartPanel();
      if (mobileOpen) closeMobile();
      if (searchOpen) closeSearch();
    }
  });

  /* Product card quick-add */
  document.querySelectorAll('.prod-card').forEach(function(card) {
    var quickBtn = card.querySelector('.prod-card-quick');
    if (!quickBtn) return;
    quickBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var link = card.getAttribute('href');
      if (link) { window.location = link; }
    });
  });

  /* Init */
  fetchCart();
  initReveal();
});
